import one from '../assets/png/one.jfif'
import three from '../assets/png/3.jpg'
import lifestyle from '../assets/png/lifesyle.png'

// D:\d drive downloads\Personal_Portfolio-main\Personal_Portfolio-main\src\assets\png\lifesyle.png
export const projectsData = [{
        id: 1,
        projectName: 'Lifestylestores.com(Clone)',
        projectDesc: "lifestyle store is a leading destination for latest trends",
        tags: ['JS', 'CSS', 'HTML'],
        code: 'https://github.com/Mdshahbazalam6/lifestylestores.com',
        demo: 'https://lifestylestoresclone.netlify.app/',
        image: lifestyle
    },
    {
        id: 2,
        projectName: 'Zostel (Clone)',
        projectDesc: "Zostel is one of the largest and oldest networks of hostels and homes in India",
        tags: ['HTML', 'CSS','JS','JSON Server'],
        code: 'https://github.com/SanjanaSinghh/Zostel-Clone',
        demo: 'https://zostel-hostel-booking.netlify.app/',
        image: "https://user-images.githubusercontent.com/89686839/170731076-542d9fd1-1a23-423d-bde0-c672e0187246.png"
    },
    {
        id: 3,
        projectName: 'IMDB Clone',
        projectDesc: 'IMDb, in full Internet Movie Database, Web site that provides information about millions of films and television programs as well as their cast and crew.',
        tags: ['React','Redux','ChakraUI','Express','MongoDB'],
        code: 'https://github.com/deepaksahu3698/IMDb_clone',
        demo: 'https://imdbwebapp.netlify.app/',
        image: 'https://i.ibb.co/QcttPMB/imdb-Screen-Short-2.png'
    },
    {
        id: 4,
        projectName: 'Fitmeals',
        projectDesc: "Fitmeals.co.in is an online food delivering website, which deals with wholesome & nourishing foods.",
        tags: ['HTML', 'Css', 'Javascript'],
        code: 'https://github.com/AbhishekKasera7696/FitMeal',
        demo: 'https://featmealclone.netlify.app/',
        image: "https://i.ibb.co/qs7HYFM/Capture-fitmeals.png"
    },
   
    {
        id: 5,
        projectName: '',
        projectDesc: '',
        tags: [],
        code: '',
        demo: '',
        image: ''
    },
    {
        id: 6,
        projectName: '',
        projectDesc: '',
        tags: [],
        code: '',
        demo: '',
        image: ''
    },
    {
        id: 7,
        projectName: '',
        projectDesc: '',
        tags: [],
        code: '',
        demo: '',
        image: ''
    },
    {
        id: 8,
        projectName: '',
        projectDesc: '',
        tags: [],
        code: '',
        demo: '',
        image: ''
    },

]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/